import { useNavigation } from 'adapter/in/common/hooks/useNavigation';
import { analysisPath, reportsTemplatePath } from 'adapter/in/common/routes';
import WidgetActionsMenu from 'adapter/in/dashboards/pages/Widget/ActionsMenu';
import useOnDeleteReportAnalysisModal from 'adapter/in/reports/components/DeleteReportAnalysisModal/useDeleteReportAnalysisModal';
import React from 'react';

interface ReportAnalysisActionsMenuProps {
    analysisId: string;
    dashboardId: string;
    showMenu: boolean;
}

const ReportAnalysisActionsMenuContainer: React.FC<ReportAnalysisActionsMenuProps> = (props) => {
    const { analysisId, dashboardId, showMenu } = props;
    const { navigationPush } = useNavigation();
    const { onDeleteModal, handleOnDelete } = useOnDeleteReportAnalysisModal(dashboardId, analysisId);

    return (
        <>
            <WidgetActionsMenu
                show={showMenu}
                showOptions={false}
                onDelete={() => {
                    handleOnDelete();
                }}
                onEdit={() => {
                    navigationPush(`${analysisPath}/${analysisId}`, `${reportsTemplatePath}/${dashboardId}`);
                }}
                isEditDisabled={() => false}
            />
            {onDeleteModal}
        </>
    );
};

export default ReportAnalysisActionsMenuContainer;
